import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import './NavBar.css';
import { IMAGE_BASE_URL } from '../constants/paths';
import Logo from '../assets/logo.png';

const Navbar = () => {
  const [activeLink, setActiveLink] = useState('');
  const [active, setActive] = useState('home');
  const [isOpen, setIsOpen] = useState(false);

  const church = JSON.parse(localStorage.getItem('church'));
  const { token } = useParams();
  const logoPath = church && church.logo ? IMAGE_BASE_URL + church.logo : Logo;


  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      setActive(id);
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false); // close mobile menu on click
    }
  };

 useEffect(() => {
  const handleScroll = () => {
    const navbar = document.querySelector('.navbar');
    if (window.scrollY > 50) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);


  return (
    <nav className="navbar">
      <div className="navbar-container container">
        <div className="logo">
          <img
            crossOrigin="anonymous"
            src={logoPath}
            alt="LOGO"
            style={{ width: '70px', height: '70px',borderRadius:"50px" }}
          />
        </div>

        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <span className={`line ${isOpen ? 'rotate1' : ''}`}></span>
          <span className={`line ${isOpen ? 'fade' : ''}`}></span>
          <span className={`line ${isOpen ? 'rotate2' : ''}`}></span>
        </div>

        <ul className={`menu-items ${isOpen ? 'open' : ''}`}>
          <li>
            <Link
              to={`/${church?.website}`}
              onClick={() => scrollToSection('home')}
              className={active === `/${church?.website}` ? 'nav-link-active' : ''}
            >
              Home
            </Link>
          </li>

           <li>
            <Link
              to={`/${church?.website}#events`}
              onClick={() => scrollToSection('events')}
              className={active === `/${church?.website}/events` ? 'nav-link-active' : ''}
            >
              Events
            </Link>
          </li>

           <li>
            <Link
              to={`/${church?.website}`}
              onClick={() => scrollToSection('ministries')}
              className={active === `/${church?.website}/ministries` ? 'nav-link-active' : ''}
            >
              Ministries
            </Link>
          </li>

            <li>
            <Link
              to={`/${church?.website}`}
              onClick={() => scrollToSection('sermons')}
              className={active === `/${church?.website}/sermons` ? 'nav-link-active' : ''}
            >
              Sermons
            </Link>
          </li>

              <li>
            <Link
              to={`/${church?.website}`}
              onClick={() => scrollToSection('volunteer-opportunities')}
              className={active === `/${church?.website}/volunteer-opportunites` ? 'nav-link-active' : ''}
            >
              Opportunites
            </Link>
          </li>

             <li>
            <Link
              to={`/${church?.website}`}
              onClick={() => scrollToSection('about')}
              className={active === `/${church?.website}/about` ? 'nav-link-active' : ''}
            >
              About Us
            </Link>
          </li>

            <li>
            <Link
              to={`/${church?.website}/#contact`}
              onClick={() => scrollToSection('contact')}
              className={active === `/${church?.website}/contact-us` ? 'nav-link-active' : ''}
            >
              Contact Us
            </Link>
          </li>
        
          
          {/*<li><Link to={`/${church && church.website}/events`}>Events</Link></li>*/}
               {/* <li><Link to={`/${church && church.website}/community-engagements`}>Missions</Link></li> */}
               {/* <li><Link to={`/${church && church.website}/sermons`}>Sermons</Link></li>
                <li><Link to={`/${church && church.website}/contact-us`}>Contact Us</Link></li>
                <li><Link to={`/${church && church.website}/about`}>About</Link></li>*/}
              
                
                
        
          {
         /* church?.subscription_type.toLowerCase() === 'premium' && (
            <li>
              <Link to={`/${church.website}/donate-with-paypal`} className="btn give-button">
                Give
              </Link>
            </li>
          )*/
          }
        </ul>

      
      </div>
    </nav>
  );
};

export default Navbar;


